
import $ from 'jquery';
import {findObjectById, getLocacion} from '../../util';



export class CrucigramaPalabrasApi {
    
    static activar(id, token) {  
       return $.ajax({
            headers: {"Authorization": "Bearer " + token.idToken}, 
        	url: getLocacion()+ "/api/crucigramapalabras/activar/"+id,
			type: "PUT",
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
				
			}
		});
	}
    
    
     static borrar(id, token) {  
       return $.ajax({
            headers: {"Authorization": "Bearer " + token.idToken}, 
        	url: getLocacion()+ "/api/crucigramapalabras/"+id,
			type: "DELETE",
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
				
			}
		});
	}
    
    
    static getCrucigramaPalabrasList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token ) {
        
         return $.ajax({
            headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/crucigramapalabras?page="+pagina+"&size="+regitrosPorPagina+"&filtro="+filtro+"&activos="+showActivos,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
      
	}
    
    
    static getCrucigrama(id, token ) {
        
         return $.ajax({
            headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/crucigramapalabras/lista/"+id,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
      
	}
    
    
    static getCrucigramaPalabras(id, token ) {  
         return $.ajax({
            headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/crucigramapalabras/"+id,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
        
	}
    
    
    static save(crucigramapalabras, token ) {          
      let crucigramapalabrasEnvio = Object.assign({}, crucigramapalabras);
		let comando="POST";
		if (crucigramapalabrasEnvio.id > 0) {
			comando="PUT";			
		} 
		crucigramapalabrasEnvio=JSON.stringify(crucigramapalabrasEnvio);
		return $.ajax({
            headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/crucigramapalabras/",
			type: comando,
			contentType: "application/json; charset=utf-8",
			dataType: "json",
			data: crucigramapalabrasEnvio,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
	}   
    
    
     static savePosition(crucigramapalabras, token ) {          
         let comando="PUT";
         let envio ={
             "crucigramaWordsUI":crucigramapalabras
         }
         
        envio=JSON.stringify(envio);
         
		return $.ajax({
            headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/crucigramapalabras/posicion/",
			type: comando,
			contentType: "application/json; charset=utf-8",
			dataType: "json",
			data: envio,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
	}   
    
    
    static getCrucigramaPalabrasCombo(token ) {

		return $.ajax({
            headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/crucigramapalabras/combo/",
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
	}
    
     

    
}